require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-111-duplicate-a-project.json") })
        }
      }, "path---article-111-duplicate-a-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-111-duplicate-a-project!./.cache/json/article-111-duplicate-a-project.json
// module id = 469
// module chunks = 231608221292675